/**
 * Waits the specified milliseconds before resolving.
 * @param ms Milliseconds to sleep/wait.
 * @returns resolves promise
 */
export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms))
